import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Views from "./views";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./translations/i18n";
import { useFirestoreConnect } from "react-redux-firebase";
import { FIRESTORE_INVITED_USERS_TABLE, FIRESTORE_USERS_TABLE } from "./constants/FirestoreConstant";
import nlNL from "antd/lib/locale/nl_NL";
import "bootstrap/dist/css/bootstrap.css";
import { ConfigProvider } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import "./assets/css/globals.css";
import "dayjs/locale/nl";
import * as dayjs from "dayjs";

dayjs.locale("nl");

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const App = () => {
  // Fetch invited users and CMS users
  useFirestoreConnect([
    { collection: FIRESTORE_INVITED_USERS_TABLE },
    {
      collection: FIRESTORE_USERS_TABLE,
      where: ["role", "in", ["cmsUser", "cmsAdmin"]],
      storeAs: "cmsUsers",
    },
  ]);

  return (
    <div className="App">
      <ThemeSwitcherProvider
        themeMap={themes}
        defaultTheme={THEME_CONFIG.currentTheme}
        insertionPoint="styles-insertion-point"
      >
        <StyleProvider>
          <ConfigProvider
            locale={nlNL}
            theme={{
              token: {
                colorPrimary: "#F39F2D",
              },
            }}
          >
            <Router>
              <Switch>
                <Route path="/" component={Views} />
              </Switch>
            </Router>
          </ConfigProvider>
        </StyleProvider>
      </ThemeSwitcherProvider>
    </div>
  );
};

export default App;
